module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-checkbox-group', _vm._b({
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, 'el-checkbox-group', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21674857"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/checkbox/rtCheckboxGroup.vue
// module id = 1471
// module chunks = 124